<template>
  <div class="form">
    <div v-for="category in Object.keys(categories)" :key="category">
      <div class="full-width category">
        <div class="title">{{ category }}</div>
        <CustomizationField
          v-for="field in categories[category].items"
          :key="field.key"
          :field="field"
          class="mb-3"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import CustomizationField from "./CustomizationField.vue";
import { injectUseTenantCustomization } from "./useTenantCustomization";

const { fields } = injectUseTenantCustomization();
const skipFields = ["pinicon_url"];

const categories = computed(() => {
  return fields.value.reduce((fields, field) => {
    if (skipFields.includes(field.key)) {
      return fields; // Skip processing if the field key is in the skipFields array
    }
    // Don't display the Schedule Colors in the right menu
    if (field.category === "Schedule Colors") {
      return fields;
    }
    if (fields[field.category]) {
      fields[field.category].items.push(field);
    } else {
      fields[field.category] = {
        items: [field]
      };
    }
    return fields;
  }, {});
});
</script>

<style scoped>
.title {
  font-size: 18px;
  border-bottom: 1px solid #c7cfd3;
  padding-bottom: 8px;
  margin-bottom: 16px;
  font-weight: 600;
}

.form {
  height: 100%;
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
